/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Maria_Ward_Schule_Aschaffenburg4Inputs */

const en__field_enum_maria_ward_schule_aschaffenburg4 = /** @type {(inputs: _Field_Enum_Maria_Ward_Schule_Aschaffenburg4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aschaffenburg`)
};

const de__field_enum_maria_ward_schule_aschaffenburg4 = /** @type {(inputs: _Field_Enum_Maria_Ward_Schule_Aschaffenburg4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maria-Ward-Schule`)
};

/**
* | output |
* | --- |
* | "Aschaffenburg" |
*
* @param {_Field_Enum_Maria_Ward_Schule_Aschaffenburg4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_maria_ward_schule_aschaffenburg4 = /** @type {((inputs?: _Field_Enum_Maria_Ward_Schule_Aschaffenburg4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Maria_Ward_Schule_Aschaffenburg4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_maria_ward_schule_aschaffenburg4(inputs)
	return de__field_enum_maria_ward_schule_aschaffenburg4(inputs)
});
export { _field_enum_maria_ward_schule_aschaffenburg4 as "_field_enum_Maria_Ward_Schule_Aschaffenburg" }